export default "/images/vendor/flag-icon-css/flags/1x1/sb.svg?00988e025b134db9744329626d126aab";